import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "react-simple-snackbar";
import rzpsvg from "../assets/plans/razorpay-logo.5cdb58df 1.svg";
import stripesvg from "../assets/plans/Group.svg";
import Loder from "../components/loder";
import razorpayPaymentHelper from "../helpers/RazorpayPaymentHelper";
import SubscriptionMessageModal from "../components/MessageModal/SubscriptionMessageModal";
import { dayRemaining, getDate, UTCtoLocalConverter } from "../helpers/TimeDate";
import {
  ApplyCuponCode,
  CaptureStripePayment,
  FetchAllPlan,
  getPlan,
} from "../redux/actions/PlanAction";
import { useHistory } from "react-router";
import { currencyConverter, getDiscount } from "../helpers/planPrice";
import { openInNewTab } from "../helpers/LoadDoc";
import Swal from "sweetalert2";
import { UpgradePlan } from "../redux/actions/UserAction";
import { initGA, initPixel } from "../helpers/CampaignEvents";

const UpgradePage = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const time_zone = JSON.parse(localStorage.getItem("TIMEZONE"));
  const UserLocaldata = JSON.parse(localStorage.getItem("USER"));
  const currency = JSON.parse(localStorage.getItem("CURRENCY"));

  const [openSnackbar, closeSnackbar] = useSnackbar();

  const [content, setContent] = useState(null);
  const [planDetails, setPlanDetails] = useState(null);
  const [duration, setDuration] = useState("25min");
  const [day, setDay] = useState(7);
  const [month, setMonth] = useState("12");
  const [wallet, setWallet] = useState(false);
  const [walletAmount, setWalletAmount] = useState(0);
  const [usdPrice, setUSDprice] = useState(0);

  const [cuponCode, setCuponCode] = useState("");
  const [cuponAmount, setCuponAmount] = useState(0);

  const [show, setShow] = useState(false);
  const [subscribeLoder, setSubscribeLoder] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("Razorpay");
  //calculation
  const [grandTotal, setGrandTotal] = useState("");
  const [gstAmount, setGstAmount] = useState("");
  const [cupondiscount, setCuponDiscount] = useState("");
  const [totalPlanPrice, settotalPlanPrice] = useState(null);

  //redux stote
  const currentplan = useSelector((state) => state.PlanReducer.currentplan);
  const Plans = useSelector((state) => state.PlanReducer.plans);
  const userWallet = useSelector(
    (state) => state.UserReducer.learnerWalletHistory
  );
  const User = useSelector((state) => state.UserReducer.user);
  //helper const

  const remainingSessionCost =
    (props.location.state?.amount / props.location.state?.totalSession) *
    props.location.state?.availableSession;
  const filteredMonth = content?.months.filter(
    (remainingMonth) => remainingMonth.no >= props.location.state?.month
  );
  const filteredDuration = content?.durations.filter((remainingDuration) => remainingDuration );
  const filteredFrequency = content?.frequencies.filter(
    (remainingFrequency) =>
      remainingFrequency >= props.location.state?.plan.frequency
  );
  const upgradeUsd =
    (planDetails?.originalPrice * month) / usdPrice -
    (props.location.state.currency == "USD"
      ? remainingSessionCost
      : remainingSessionCost / usdPrice);
  const bool = day > props.location.state?.plan.frequency;

  useEffect(() => {
    if (currentplan) {
      Plans.map((data) => {
        if (data._id === currentplan.plan._id) {
          settotalPlanPrice(data);
        }
      });
    }
  }, [Plans, currentplan]);

  useEffect(() => {
    initPixel();
    initGA();
    const onSuccess = (data) => {
      console.log(data);
      setContent(data);
    };
    dispatch(getPlan(onSuccess));
    dispatch(FetchAllPlan());

    if (userWallet) {
      userWallet.slice(0, 1).map((data) => {
        //console.log(data.closingBalance)
        setWalletAmount(data.closingBalance);
      });
    }
  }, []);

  useEffect(() => {
    Plans.map((data, i) => {
      if (data.classDuration === duration && data.frequency === day) {
        setPlanDetails(data);
      }
    });
  }, [duration, day]);

  useEffect(() => {
    if (UserLocaldata.influencer) {
      setCuponCode(UserLocaldata.influencer.toLowerCase());
    }
    const onSuccess = (data) => {
      console.log(data);
      setContent(data);
    };
    dispatch(getPlan(onSuccess));
    dispatch(FetchAllPlan());

    if (userWallet) {
      userWallet.slice(0, 1).map((data) => {
        //console.log(data.closingBalance)
        setWalletAmount(data.closingBalance);
      });
    }

    setUSDprice(currency ? currency : 0);
  }, []);

  useEffect(() => {
    if (planDetails) {
      var total;
      var cuponorwallet;
      var walletmoney = 0;
      //discount price
      if (cuponCode && wallet) {
        cuponorwallet = Math.round(
          ((planDetails.originalPrice * month - walletAmount) / 100) *
            cuponAmount
        );
        walletmoney = walletAmount;
      } else if (wallet) {
        cuponorwallet = walletAmount;
      } else if (cuponCode) {
        cuponorwallet = Math.round(
          ((planDetails.originalPrice * month) / 100) * cuponAmount
        );
      } else {
        cuponorwallet = 0;
      }

      setCuponDiscount(cuponorwallet);
      //total amount
      // total = Math.round((planDetails.originalPrice * month) -  cuponorwallet - walletmoney)
      // //gst amount
      // var gstamount = Math.round((total / 100) * 18)
      // setGstAmount(gstamount)
      var selected = Math.round(planDetails?.originalPrice * month);
      var remainingSess = Math.round(remainingSessionCost);
      var difference = selected - remainingSess;
      var gst = Math.round((difference / 100) * 18);
      setGstAmount(gst);
      total = difference + gst;
      setGrandTotal(total);
    }
  }, [month, planDetails, cuponCode, wallet]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  //payment
  console.log();
  const upgrade = (amount) => {
    console.log(amount);
    setSubscribeLoder(true);
    const userCurrency = time_zone.country === "IN" ? "INR" : "USD";
    const userData = time_zone.timezone;
    const val = userData.split("/");
    const data = {
      amount: amount,
      payment_capture: 1,
      currency: userCurrency,
      notes: {
        Name: User.name,
        Number: User.phoneNumber,
        Email: User.email,
        subscriptionId: props.location.state?._id,
        planId: planDetails._id,
        paymentDetails:
          planDetails.courseName + " Upgrade Subscription (from web)",
        month: parseInt(month),
        amount: planDetails.originalPrice,
        zone1: val[0],
        zone2: val.length > 1 ? val[1] : undefined,
        isNewSchema: true,
      },
      txndesc: `${planDetails.courseName} Upgrade`,
      source: getDiscount(),
    };

    const onSuccess = (rzpRes) => {
      var data = {
        learnerId: User._id,
        transactionId: rzpRes.razorpay_order_id,
        planId: planDetails._id,
        subscriptionId: props.location.state?._id,
        paymentDetails:
          planDetails.courseName + " Upgrade Subscription (from web)",
        month: month,
        amount: planDetails.originalPrice,
        timezone: time_zone.timezone,
        order_id: rzpRes.razorpay_order_id,
        subscriptionName: planDetails.courseName,
        currency: userCurrency,
      };

      const subscriptionSuccess = () => {
        localStorage.setItem("SUBSCRIBED", JSON.stringify(true));
        handleShow();
        setSubscribeLoder(false);
      };

      const subscriptionFailed = (errmsg) => {
        setSubscribeLoder(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: errmsg,
        });
      };

      dispatch(UpgradePlan(data, subscriptionSuccess, subscriptionFailed));
    };

    const modalClose = () => {
      setSubscribeLoder(false);
    };
    razorpayPaymentHelper(data, onSuccess, modalClose);
  };

  const stripePayment = (amount) => {
    setSubscribeLoder(true);
    console.log(amount);
    const userCurrency = time_zone.country === "IN" ? "INR" : "USD";
    const userData = time_zone.timezone;
    const val = userData.split("/");
    const calculatedAmount = time_zone.country === "IN" ? amount : amount / 100;

    const data = {
      amount: amount,
      currency: userCurrency,
      txndesc: `${planDetails.courseName} Upgrade`,
      success_url: window.location.origin + "/dashboard",
      cancel_url: window.location.href,
      source: getDiscount(),
      notes: {
        subscriptionName: planDetails.courseName,
        learnerID: User._id,
        paymentDetails: planDetails.originalPrice + " Upgrade Plan (from web)",
        month: parseInt(month),
        planId: planDetails._id,
        amount: calculatedAmount,
        subscriptionId: props.location.state?._id,
        zone1: val[0],
        zone2: val.length > 1 ? val[1] : undefined,
        isNewSchema: true,
        currency: userCurrency,
        desc: planDetails.courseName,
        type: "Upgrade_Subscription",
        statusCode: "200",
        learner: User._id,
      },
    };

    const onSuccess = (response) => {
      setSubscribeLoder(false);
      openInNewTab(response.redirectUrl);
    };

    const onError = (errmsg) => {
      setSubscribeLoder(false);
      openSnackbar(errmsg?.data?.message);
    };

    dispatch(CaptureStripePayment(data, onSuccess, onError));
  };



  return (
    <div className="plan_price_container">
      <SubscriptionMessageModal show={show} handleClose={handleClose} />
      {/* <hr className="line"></hr> */}
      <div className="session_card content mt-5 mt-md-2">
        <div className="card mx-auto">
        <div className="d-md-flex ">
          <div className="current-plan-root">
          <div className="current-plan plan-card ">
            <div className="d-flex justify-content-between">
              <div className="plan-name">
              <p >CURRENT PLAN</p>
              <h1>{props?.location?.state?.plan?.courseName}</h1>
              </div>
              <div className="plan-duration">
              <h1>{props?.location?.state?.plan?.classDuration}.</h1>
              <p>per session</p>
              </div>
            </div>

              <li>{props?.location?.state?.plan?.frequency} day per week</li>
              <li>{props?.location?.state?.plan?.frequency * props?.location?.state?.month } sessions for {props?.location?.state?.month} months</li>
              <li>Expires on {UTCtoLocalConverter(props?.location?.state?.endDate)}</li>
          </div>
          </div>

          <div className="selected-plan-root mt-md-0 mt-3">

          <div className="selected-plan plan-card">
          <div className="d-flex justify-content-between">
              <div className="plan-name">
              <p >SELECTED PLAN</p>
              <h1>{planDetails?.courseName}</h1>
              </div>
              <div className="plan-duration">
              <h1>{planDetails?.classDuration}.</h1>
              <p>per session</p>
              </div>
            </div>

              <li>{day} day per week</li>
              <li>{month* day * 4 } sessions for {month} months</li>

          </div>
          </div>
        </div>

          <div className="d-md-flex mt-5">
            <div className="plan-details">
              <div className="duration">
                <h6>Select Duration</h6>
                <div className="d-md-flex p-2">
                  {content ? (
                    <>
                      <div className="dropdown m-1">
                        <button
                          className="btn dropdown-toggle"
                          type="button"
                          id="dropdownMinute"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          {duration} per session
                        </button>

                        <div
                          className="dropdown-menu"
                          aria-labelledby="dropdownMinute"
                        >
                          {filteredDuration.map((data, i) => (
                            <span
                              className="dropdown-item"
                              key={i}
                              onClick={() => setDuration(data)}
                            >
                              {data} per session
                            </span>
                          ))}
                        </div>
                      </div>

                      <div className="dropdown m-1">
                        <button
                          className="btn dropdown-toggle"
                          type="button"
                          id="dropdownWeek"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          {day} day per week
                        </button>
                        <div
                          className="dropdown-menu"
                          aria-labelledby="dropdownWeek"
                        >
                          {filteredFrequency.map((data, i) => (
                            <span
                              className="dropdown-item"
                              key={i}
                              onClick={() => setDay(data)}
                            >
                              {data} day per week
                            </span>
                          ))}
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="text-center mx-auto m-5">
                      <Loder />
                    </div>
                  )}
                </div>
              </div>

              <div className="target mt-2 p-2 mt-md-4">
                <h6>Select Target</h6>

                {filteredMonth ? (
                  filteredMonth
                    .sort((x, y) => {
                      return y.no - x.no;
                    })
                    .map((data, i) => (
                      <div key={i}>
                        <input
                          type="radio"
                          id={data.no + "plan"}
                          value={data.no}
                          onChange={(e) => {
                            setMonth(e.target.value);
                          }}
                          name="radio-group"
                        />
                        <label
                          className={`price-card mt-3 ${
                            month === data.no.toString()
                              ? "active-price-card "
                              : ""
                          }`}
                          htmlFor={data.no + "plan"}
                        >
                          <div className="d-flex justify-content-between price-card-body">
                            <div>
                              <h4>{data.no} Month</h4>
                              <p>
                                No. of sessions:{" "}
                                <strong>{data.no * day * 4}</strong>
                              </p>
                            </div>
                            <h3 className="price my-auto">
                              <strong>
                                {planDetails
                                  ? time_zone.country === "IN"
                                    ? "₹ " +
                                      Math.round(
                                        planDetails.originalPrice -
                                          (planDetails.originalPrice / 100) *
                                            data.discount
                                      )
                                    : currencyConverter(
                                        Math.round(
                                          planDetails.originalPrice -
                                            (planDetails.originalPrice / 100) *
                                              data.discount
                                        ) / usdPrice
                                      )
                                  : 0}
                              </strong>
                              /mth.
                            </h3>
                          </div>
                          {data.no === 6 || data.no === 12 ? (
                            <span className="badge">MOST SELECTED</span>
                          ) : (
                            ""
                          )}
                          {/* <span className="label">SAVE {data.discount}%</span> */}
                        </label>
                      </div>
                    ))
                ) : (
                  <div className="text-center m-5">
                    <Loder />
                  </div>
                )}
              </div>
            </div>
            <div className="billing">
              <h6>BILL SUMMARY</h6>
              <div className="summery mt-4">
                <div className="d-flex justify-content-between">
                  <p>Sub-Total :</p>
                  <p>
                    {time_zone.country === "IN"
                      ? "₹" +
                        new Intl.NumberFormat().format(
                          Math.round(planDetails?.originalPrice * month)
                        )
                      : currencyConverter(
                          Math.round(planDetails?.originalPrice * month) /
                            usdPrice
                        )}
                  </p>
                </div>
                <div className="d-flex justify-content-between">
                  <p className="discount">Remaining Session Price:</p>
                  <p className="discount">
                    {time_zone.country === "IN"
                      ? "-₹" +
                        new Intl.NumberFormat().format(
                          Math.round(remainingSessionCost)
                        )
                      : props.location.state.currency == "USD"
                      ? `-$${remainingSessionCost}`
                      : "-" +
                        currencyConverter(remainingSessionCost / usdPrice)}
                  </p>
                </div>
                {time_zone.country === "IN" ? (
                  <div className="d-flex justify-content-between">
                    <p>GST Charges(18%) :</p>
                    <p> ₹ {new Intl.NumberFormat().format(gstAmount)}</p>
                  </div>
                ) : (
                  ""
                )}

                <hr />
                <div className="d-flex justify-content-between grand-total">
                  <p className="grand-total">Grand Total :</p>
                  <p>
                    {time_zone.country === "IN"
                      ? "₹" +
                        new Intl.NumberFormat().format(Math.round(grandTotal))
                      : currencyConverter(Math.round(upgradeUsd * 100) / 100)}
                  </p>
                </div>
              </div>

              <div className="make-payment mt-3">
                <h6>MAKE PAYMENT USING</h6>
                {grandTotal < 0 ? (
                        <p className="text-danger text-center">
                          {" "}
                          Upgrade price must be higher than remaining session
                          price
                        </p>
                      ) : currentplan?.plan?.frequency === day &&
                        currentplan?.plan?.classDuration === duration &&
                        currentplan?.month === Number(month) ? (
                        <p className="text-danger text-center">
                          You are already on this plan
                        </p>
                      ) : (
                        ""
                      )}
                <div className="d-md-flex justify-content-between mt-3">
                  <div
                    className={`payment-selector ${
                      paymentMethod === "Razorpay" ? `active` : ""
                    }`}
                  >
                    <input
                      type="radio"
                      id="razorpay"
                      value="Razorpay"
                      name="radio-group"
                      onChange={(e) => setPaymentMethod(e.target.value)}
                      checked={paymentMethod === "Razorpay"}
                    />
                    <label htmlFor="razorpay">
                      <img src={rzpsvg} className="mt-2" alt="razorpay" />
                    </label>
                  </div>
                  <div
                    className={`payment-selector ${
                      paymentMethod === "Stripe" ? `active` : ""
                    }`}
                  >
                    <input
                      type="radio"
                      id="stripe"
                      value="Stripe"
                      name="radio-group"
                      onChange={(e) => setPaymentMethod(e.target.value)}
                      checked={paymentMethod === "Stripe"}
                    />
                    <label htmlFor="stripe">
                      <img src={stripesvg} className="mt-2" alt="stripe" />
                    </label>
                  </div>
                </div>
                <div className="d-flex justify-content-center mt-3">
                  {paymentMethod === "Razorpay" ? (
                    <>
                      <button
                        id="makepaymentid"
                        className="payment_btn mx-auto mt-2"
                        disabled={subscribeLoder}
                        onClick={() => upgrade(grandTotal)}
                      >
                        {subscribeLoder
                          ? "Processing..."
                          : "Proceed to Payment"}
                      </button>
                      {/* <p className="mt-2" style={{ fontSize: "13px" }}>
                      EMI options available
                    </p> */}
                    </>
                  ) : (
                    <>
                      <button
                        id="makepaymentid"
                        className="payment_btn mx-auto mt-2"
                        onClick={() => stripePayment(grandTotal)}
                        disabled={subscribeLoder}
                      >
                        {subscribeLoder
                          ? "Processing..."
                          : "Proceed to Payment"}
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradePage;
